import * as React from 'react'
import { Info as InfoIcon } from 'lucide-react'

/**
 * Muted inline notice for Plant Viewer list/flow sections whose render
 * order carries no meaning in the graph (missing or incomplete FEEDS
 * relationships, unmodeled subprocess order). Makes the alphabetical
 * fallback visible instead of letting it read as a real process order.
 */
export function UnorderedNotice({ children }: { children: React.ReactNode }): React.ReactElement {
  return (
    <p className="m-0 mb-2 flex items-center gap-1.5 text-11 text-ink-3">
      <InfoIcon size={12} className="shrink-0" aria-hidden />
      <span>{children}</span>
    </p>
  )
}
